export const getImgUrl = {
  methods: {
    getImgUrl(url) {
      if (url !== "null") {
        let images = require.context(
          "@/assets/images/payments/",
          false,
          /\.png$/
        );
        return images("./" + url + ".png");
      }
    }
  }
};
